// 个人中心
export default [
	{
		path: '/user',
		redirect: '/user/home',
		name: 'User',
		component: () => import('@/views/user/index'),
		meta: { title: '个人中心' },
		children: [
			{
				path: 'home',
				name: 'UserHome',
				component: () => import('@/views/user/userHome'),
				meta: { title: '我的主页' }
			},
			{
				path: 'profile',
				name: 'UserProfile',
				component: () => import('@/views/user/profile'),
				meta: { title: '个人资料' }
			},
			{
				path: 'message',
				name: 'UserMessage',
				component: () => import('@/views/user/message'),
				meta: { title: '消息通知' }
			},
			// 我的发票（新）
			{
				path: 'invoiceManagement',
				name: 'InvoiceManagement',
				component: () => import('@/views/user/invoiceManagement/index.vue'),
				meta: { title: '我的发票' },
				children: [
					{
						path: 'myInvoice',
						name: 'MyInvoice',
						component: () => import('@/views/user/invoiceManagement/invoice'),
						meta: { title: '我的发票' }
					},
					{
						path: 'invoiceTitle',
						name: 'InvoiceTitleManagement',
						component: () => import('@/views/user/invoiceManagement/invoiceTitle'),
						meta: { title: '发票抬头管理' }
					}
				]
			},
			{
				path: 'common',
				redirect: '/user/common/company',
				name: 'UserCommon',
				component: () => import('@/views/user/common/index.vue'),
				meta: { title: '常用功能' },
				children: [
					{
						path: 'company',
						name: 'UserCompany',
						component: () => import('@/views/user/companyManagement'),
						meta: { title: '我的企业' }
					},
					// 保留旧版“我的企业”，便于新旧业务并行核对及后续回退
					{
						path: 'company-legacy',
						name: 'UserCompanyLegacy',
						component: () => import('@/views/user/common/company'),
						meta: { title: '我的企业（旧）' }
					},
					{
						path: 'company/auth',
						name: 'CompanyAuth',
						component: () => import('@/views/user/common/companyAuth'),
						meta: { title: '企业认证' }
					},
					{
						path: 'subscription',
						name: 'UserSubscription',
						component: () => import('@/views/user/common/subscription'),
						meta: { title: '我的订阅' }
					}
				]
			},
			{
				path: 'monitor',
				redirect: '/monitor/list',
				name: 'UserMonitor',
				component: () => import('@/views/user/monitor/index.vue'),
				meta: { title: '监控预警' },
				children: [
					{
						path: 'list',
						name: 'MonitorList',
						component: () => import('@/views/user/monitor/list'),
						meta: { title: '监控列表' }
					},
					{
						path: 'message-settings',
						name: 'MonitorMessageSettings',
						component: () => import('@/views/user/monitor/message-settings'),
						meta: { title: '监控消息设置' }
					},
					{
						path: 'settings',
						name: 'MonitorSettings',
						component: () => import('@/views/user/monitor/settings'),
						meta: { title: '监控设置' }
					}
				]
			},
			{
				path: 'market',
				redirect: '/user/market/order',
				name: 'UserMarket',
				component: () => import('@/views/user/market/index'),
				meta: { title: '会员管理' },
				children: [
					{
						path: 'order',
						name: 'OrderList',
						component: () => import('@/views/user/market/order'),
						meta: { title: '商品发布订单' }
					},
					{
						path: 'order/select',
						name: 'OrderSelect',
						component: () => import('@/views/user/market/orderSelect'),
						meta: { title: '申请开票' }
					},
					{
						path: 'invoice',
						name: 'InvoiceList',
						component: () => import('@/views/user/market/invoice'),
						meta: { title: '我的发票' }
					},
					{
						path: 'coupon',
						name: 'CouponList',
						component: () => import('@/views/user/market/coupon'),
						meta: { title: '我的优惠券' }
					},
					{
						path: 'my-member-benefits',
						name: 'MyMemberBenefits',
						component: () => import('@/views/user/market/memberBenefits'),
						meta: { title: '会员权益' }
					},
					{
						path: 'my-member-benefits-record',
						name: 'MyMemberBenefitsRecord',
						component: () => import('@/views/user/market/memberBenefitsRecord'),
						meta: { title: '会员权益使用记录' }
					}
				]
			},
			{
				path: 'shoppmanag',
				redirect: '/user/shoppmanag/shoppOrder',
				name: 'ShoppManag',
				component: () => import('@/views/user/shoppmanag/index'),
				meta: { title: '购物管理' },
				children: [
					{
						path: 'shoppOrder',
						name: 'ShoppOrder',
						component: () => import('@/views/user/shoppmanag/shoppOrder'),
						meta: { title: '购物订单' }
					},
					// 购物车
					{
						path: 'shoppingCart',
						name: 'ShoppingCart',
						component: () => import('@/views/user/shoppmanag/shoppingCart'),
						meta: { title: '购物车' }
					},
					// 我的权益
					{
						path: 'myBenefits',
						name: 'MyBenefits',
						component: () => import('@/views/user/shoppmanag/myBenefits'),
						meta: { title: '我的权益' }
					},
					// 查看指定订单的权益清单。
					{
						path: 'myBenefits/remaining',
						name: 'MyBenefitRemaining',
						component: () => import('@/views/user/shoppmanag/benefitRemaining'),
						meta: { title: '剩余权益' }
					},
					// 查看指定订单下的权益使用明细。
					{
						path: 'myBenefits/usage-record',
						name: 'MyBenefitUsageRecord',
						component: () => import('@/views/user/shoppmanag/benefitUsageRecord'),
						meta: { title: '权益使用记录' }
					},
					// 原有报告导出、我的收藏页面迁移为“我的权益”的子功能。
					{
						path: 'myBenefits/export',
						name: 'UserExport',
						component: () => import('@/views/user/common/export'),
						meta: { title: '报告导出' }
					},
					{
						path: 'myBenefits/collection',
						name: 'UserCollection',
						component: () => import('@/views/user/common/collection'),
						meta: { title: '我的收藏' }
					},
					// 我的券包
					{
						path: 'myCoupon',
						name: 'MyCoupon',
						component: () => import('@/views/user/shoppmanag/myCoupon'),
						meta: { title: '我的券包' }
					},
					// 优惠券使用规则说明
					{
						path: 'myCoupon/rules',
						name: 'CouponRules',
						component: () => import('@/views/user/shoppmanag/couponRules'),
						meta: { title: '优惠券使用规则说明' }
					}
				]
			}
		]
	}
]
